import { render } from "./PwaUpdateComponent.vue?vue&type=template&id=0e62ad06&ts=true"
import script from "./PwaUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./PwaUpdateComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__